var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.accessibleTabs),function(item){return _c('div',{key:item.label,staticClass:"mb-5"},[_c('h2',{staticClass:"mb-3"},[_vm._v(_vm._s(item.label))]),_c(_vm.selectTabType(item.type),{tag:"component",attrs:{"tabConfig":item,"device":_vm.device,"permissionChecker":_vm.permissionChecker}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }